import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { DialogComponent } from '../../dialog/dialog.component'

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  @ViewChild('dialog') dialogRef: DialogComponent

  color = 'accent'
  icon = 'close'
  message = ''
  title = 'Error'

  constructor() { }

  ngOnInit() {}

  show () {
    return this.dialogRef.show()
  }
}
